import React ,{useEffect} from 'react';
import {
  
    DialogActions,Typography
  } from "@mui/material";

  import PropTypes from 'prop-types'
  import lottie from "lottie-web";
  import * as config from "../../../next.config.js"
 
  import {useTranslation} from 'next-i18next'
  import {Customebtn} from "../StyledComponent/HintDialog1.style"
  import {CustomeBox} from "../StyledComponent/HintDialog1.style"
  import {BootstrapDialog} from "../StyledComponent/HintDialog1.style"
  import {CustomeDialogContent} from "../StyledComponent/HintDialog1.style"
  
export default function AlertDialog(props) {
  const {t}=useTranslation("common")
  //  const classes=useStyles()

useEffect(()=>{
    if(props.open){
  setTimeout(() => {
    lottie.loadAnimation({
      container: document.getElementById("errorDialogId"),
      loop: false,
      autoplay: true,
      path: config.basePath +(props.type=="success"?`/json/success.json`:"/json/error.json")
    });
  })
}


},[props.open])
  return (
    <>
    <BootstrapDialog
            open={props.open}
            maxWidth={"xs"}
            fullWidth
            onClose={props.onClose}
            PaperProps={{
                sx:{overflow: "visible",position:"relative"},
              // className: classes.paper
            }}
          >
        
           {/* <div style={{position:"relative",width:"100%"}}> */}
           <CustomeBox
                // ref={props.container}
                  id="errorDialogId"
                  // sx={{
                  //   width: "100%",
                   
                  //   left: 0,
                  //   top: -190,
                  //   padding:"20px 0px",
                  //   // // top: props.children?-140:-110,
                  //   // zIndex: 100000000,
                  //   position: "absolute"
                  // }}
                ></CustomeBox>
                {/* </div> */}
            {/* <DialogTitle id="alert-dialog-title" textAlign="right" sx={{position:"relative"}}>
              {" "}
            
           
            
             
             
            </DialogTitle> */}
              
            <CustomeDialogContent style={{position:"relative",width:"100%"}}>
            <Typography
            style={{ textAlign: "center", fontWeight: "bold", color: "#F52A59", padding: "10px 0px" }}
            variant="h3"
          >
            {/* {props.text} */}
            {t("ttlMessage")}




          </Typography>
            <Typography
            style={{ textAlign: "center", fontWeight: "bold",  padding: "10px 0px" }}
            variant="h5"
              >
                    {props.text}
                 </Typography>
            </CustomeDialogContent>
            <DialogActions
              justifyContent="center"
              style={{ justifyContent: "center" }}
            >
                
            
              <Customebtn
              variant={"contained"}
              color="secondary"
                onClick={props.btnOk}
              >
            {t("btnOk")}
              </Customebtn>
            </DialogActions>
            {props.children}
          </BootstrapDialog>
    </>
  );
}
AlertDialog.propTypes={
confirm:PropTypes.func,
reject:PropTypes.func,
open:PropTypes.bool,
onClose:PropTypes.func,
text:PropTypes.string,
error:PropTypes.string
}